import { render, staticRenderFns } from "./InscripcionesPublicas.vue?vue&type=template&id=6ab4eeb5&"
import script from "./InscripcionesPublicas.vue?vue&type=script&lang=js&"
export * from "./InscripcionesPublicas.vue?vue&type=script&lang=js&"
import style0 from "./InscripcionesPublicas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports